<template>
  <div class="view">

	<box>

		<table class="table-a">
			<thead>
				<tr>
					<th class="align-l"></th>
					<th class="align-l">Kunde</th>
					<th class="align-r">Indtjening</th>
					<th class="align-r">Faktureret i Dinero</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(client,client_i) in clients">
					<td>
						<avatar :input="client"></avatar>
					</td>
					<td class="align-l">
						<router-link class="textlink" :to="'/client/'+client['.key']">{{client.name}}</router-link>
					</td>
					<td class="align-r">{{ client.earning_dkk | money(2) }} kr.</td>
					<td class="align-r">{{ client.invoiced_dkk | money(2) }} kr.</td>
				</tr>
				<tr>
					<td></td>
					<td></td>
					<td class="align-r">
						<b>{{ totalInvoiced | money(2) }} kr.</b>
					</td>
					<td></td>
				</tr>
			</tbody>
		</table>

	</box>

  </div>
</template>

<script>
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
export default {
  name: 'clients',
  mixins: [ mixins.db, mixins.generic ],
  components: { Box, Btn, Avatar },
  data: function () { return {
  
  } },
  computed:{

	clients(){

		var clients = this.getAll('clients')
		clients = clients.filter((c)=> !c.archived )

		// for each get dinero invoiced earning
		// for each get projects earning
		// sort by dinero invoiced

		for( let client of clients ) {
			client.earning_dkk = this.$store.getters['clients/get_total_earning'](client)
			client.invoiced_dkk = 0
			if( client.cvr ) client.invoiced_dkk += this.$store.getters.get_dinero_invoices_total({ client_cvr:client.cvr })
		}

		clients.sort((a,b) => b.invoiced_dkk - a.invoiced_dkk )

		return clients

	},

	totalInvoiced(){
		var total = 0
		for( let client of this.clients ) total += client.invoiced_dkk
		return total
	},

  },
  methods: {

	
  },
  
}
</script>



// WEBPACK FOOTER //
// ReportClientEarning.vue?48d42e52